import React from 'react';
import './OrganizationDialog.css';

interface Instance {
  _id: string;
  name: string;
  is_default?: boolean;
}

interface OrganizationDialogProps {
  show: boolean;
  editingId: string | null;
  formData: {
    key: string;
    name: string;
    instance_id: string;
  };
  instances: Instance[];
  onSubmit: (e: React.FormEvent) => void;
  onChange: (data: { key?: string; name?: string; instance_id?: string }) => void;
  onClose: () => void;
}

function OrganizationDialog({ show, editingId, formData, instances, onSubmit, onChange, onClose }: OrganizationDialogProps) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content edit-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>{editingId ? '✏️ Editar Organização' : '➕ Adicionar Nova Organização'}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form id="organization-form" onSubmit={onSubmit} className="dialog-form">
          <div className="form-grid">
            <div className="form-group">
              <label>Nome:</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => onChange({ name: e.target.value })}
                placeholder="Ex: Empresa XYZ"
                required
              />
            </div>

            <div className="form-group">
              <label>Key:</label>
              <input
                type="text"
                value={formData.key}
                onChange={(e) => onChange({ key: e.target.value })}
                placeholder="Ex: empresa_xyz"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Instância:</label>
              <select
                value={formData.instance_id}
                onChange={(e) => onChange({ instance_id: e.target.value })}
              >
                <option value="">Selecione uma instância</option>
                {instances.map(instance => (
                  <option key={instance._id} value={instance._id}>
                    {instance.name}{instance.is_default ? ' (padrão)' : ''}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </form>
        
        <div className="dialog-actions">
          <button type="submit" form="organization-form" className="btn-primary">
            💾 {editingId ? 'Salvar' : 'Criar'}
          </button>
          <button 
            type="button" 
            className="btn-secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrganizationDialog;

